let panelZIndexCursor = 1000;

export const nextPanelZIndex = () => {
  panelZIndexCursor += 1;
  return panelZIndexCursor;
};

export const getPanelBaseZIndex = () => {
  return panelZIndexCursor;
};
